/* eslint-disable class-methods-use-this */
import { StrapiTemplate, CSVFieldType, SectionField, SectionFieldInputType } from '../typings';
import { FieldInputType, setFieldInputType } from './templateValues';
/* eslint max-classes-per-file: ["error", 2] */
class Row {
  templatename: string = '';

  templateprefix: string = '';

  fieldrank: number = 0;

  fieldname: string = '';

  fieldlabel: string = '';

  fieldlabelDE: string = '';

  fieldlabelFR: string = '';

  fieldlabelES: string = '';

  fieldlabelZH: string = '';

  fieldtype: string = '';

  fieldoptions: string = '';

  fieldvalue: string = '';

  mandatory: number = 0;

  onchange: string = '';

  hidden: number = 0;

  group: string = '';

  linkedtable: string = '';

  onsubmit: string = '';

  dashboardjs: string = '';

  pdfoptions: string = '';

  getJson() {
    return JSON.parse(JSON.stringify(this));
  }

  getFieldType(fieldType: SectionFieldInputType): CSVFieldType {
    switch (fieldType) {
      case FieldInputType.NumberInteger: {
        return 'numeric';
      }
      case FieldInputType.Date: {
        return 'date';
      }
      case FieldInputType.LongText: {
        return 'textarea';
      }
      case FieldInputType.MultiSelect: {
        return 'selectmulti';
      }
      case FieldInputType.ShortText: {
        return 'text';
      }
      case FieldInputType.Time: {
        return 'time';
      }
      case FieldInputType.DateAndTime: {
        return 'datetime';
      }
      case FieldInputType.NumberDecimal: {
        return 'decimal';
      }
      case FieldInputType.Photo: {
        return 'photo';
      }
      case FieldInputType.SingleSelect: {
        return 'select';
      }
      case FieldInputType.Toggle: {
        return 'toggle';
      }
      case FieldInputType.Signature: {
        return 'signature';
      }
      case FieldInputType.Checkbox:
        return 'checkbox';
      case FieldInputType.Label:
        return 'label';
      default: {
        return 'text';
      }
    }
  }

  getFieldName(fieldRank: number): string {
    return `F${fieldRank.toString()}`;
  }

  isMandatory(mandatory: boolean): number {
    if (mandatory) {
      return 1;
    }

    return 0;
  }
}

export class CsvDataService {
  static exportToCsv(fileName: string, rows: object[]) {
    if (!rows || !rows.length) {
      return null;
    }
    const separator = ',';
    const keys = Object.keys(rows[0]);
    const csvData = `${keys.join(separator)}\n${rows
      .map((row: any) =>
        keys
          .map((k) => {
            let cell = row[k] === null || row[k] === undefined ? '' : row[k];
            cell = cell instanceof Date ? cell.toLocaleString() : cell.toString().replace(/"/g, '""');
            if (cell.search(/("|,|\n)/g) >= 0) {
              cell = `"${cell}"`;
            }
            return cell;
          })
          .join(separator)
      )
      .join('\n')}`;

    const fileType = 'text/csv';
    const blob = new Blob([csvData], { type: `${fileType};charset=utf-8;` });
    if (navigator.msSaveBlob) {
      // IE 10+
      navigator.msSaveBlob(blob, fileName);
    } else {
      const link = document.createElement('a');
      if (link.download !== undefined) {
        // Browsers that support HTML5 download attribute
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
    const fileData = {
      fileContent: csvData,
      fileName,
      fileType
    };
    return fileData;
  }
}

export function getTemplateJson(template: StrapiTemplate): any[] {
  const templateData: any[] = [];
  const templateName = template.Template.name;
  // let templateGroupName = template.Template.templateGroup?.name
  let rank: number = 0;

  template.Template.templateSections.forEach((templateSection) => {
    rank += 1;
    const sectionRow = new Row();
    const fieldRow = new Row();

    sectionRow.templatename = templateName;
    fieldRow.templatename = templateName;

    sectionRow.fieldlabel = templateSection.name;
    sectionRow.fieldrank = rank;
    sectionRow.fieldname = sectionRow.getFieldName(rank);
    sectionRow.fieldtype = 'header';

    templateData.push(sectionRow.getJson());

    templateSection.sectionFields.forEach((sectionField: SectionField) => {
      rank += 1;
      fieldRow.fieldrank = rank;
      fieldRow.fieldname = fieldRow.getFieldName(rank);
      fieldRow.fieldlabel = sectionField.name;
      fieldRow.fieldtype = fieldRow.getFieldType(setFieldInputType(sectionField.fieldInputType));
      fieldRow.fieldoptions = '';
      if (sectionField.selectOptions) {
        sectionField.selectOptions.forEach((option: { name: string; rank: number; color: number }) => {
          const fieldOptions = `${option.rank}:${option.name}|`;
          fieldRow.fieldoptions += fieldOptions;
        });
      }
      fieldRow.fieldoptions = fieldRow.fieldoptions.substring(0, fieldRow.fieldoptions.length - 1);
      fieldRow.mandatory = fieldRow.isMandatory(sectionField.isMandatory);
      templateData.push(fieldRow.getJson());
    });
  });
  return templateData;
}
